import { PropsWithChildren } from "react";
import { twMerge } from "tailwind-merge";

import { CancelSubmitButtons } from "~/common/components";
import Modal from "~/common/components/Modal";

interface ConfirmActionModalProps extends PropsWithChildren {
  cancelButtonClassName?: string;
  cancelButtonText?: string;
  confirmButtonClassName?: string;
  confirmButtonText?: string;
  description?: string;
  onClose: () => void;
  onConfirm?: () => void;
  show: boolean;
  title: string;
  titleClassName?: string;
  isLoading?: boolean;
}

export const ConfirmActionModal = ({
  cancelButtonClassName,
  cancelButtonText,
  confirmButtonClassName,
  confirmButtonText,
  description,
  children,
  onClose,
  onConfirm,
  show,
  isLoading = false,
  title,
  titleClassName,
}: ConfirmActionModalProps) => (
  <Modal
    className="h-fit w-96"
    titleClassName={twMerge(
      "font-outfit text-2xl font-medium tracking-wide text-gray-70",
      titleClassName,
    )}
    title={title}
    description={description}
    show={show}
    onClose={onClose}
  >
    {children}

    <div className="flex flex-col gap-3 self-end">
      <CancelSubmitButtons
        cancelClassName={cancelButtonClassName}
        handleCancel={onClose}
        cancelButtonLabel={cancelButtonText ?? "Cancel"}
        submitClassName={confirmButtonClassName}
        handleSubmit={onConfirm}
        submitButtonLabel={confirmButtonText ?? "Confirm"}
        isSubmitting={isLoading}
      />
    </div>
  </Modal>
);
